export const addQueryString = function addQueryString(url, params) {
    if (params && typeof params === 'object') {
      let queryString = '';
  
      for (const paramName in params) {
        queryString += '&' + encodeURIComponent(paramName) + '=' + encodeURIComponent(params[paramName]);
      }
  
      if (!queryString) return url;
      url = url + (url.indexOf('?') !== -1 ? '&' : '?') + queryString.slice(1);
    }
  
    return url;
};

const cleanUpFragment = (input = '') => {
    // Check if the input starts with a prefix and remove it
    if (input.includes('?')) {
        // If it contains '?', split by '?', and return the second part
        return input.split('?').slice(1).join('?');
    } else if (input.includes('&')) {
        // If it contains '&', split by '&', and return the second part
        return input.split('&').slice(1).join('&');
    } else {
        // If it doesn't contain any special character, return an empty string
        return '';
    }
}

export const extractUrlParams = (url) => {
  const parseParams = (queryString) => {
      const params = {};
      if (queryString) {
          const queries = queryString.split('&');
          queries.forEach(query => {
              const [key, value] = query.split('=');
              if (key) {
                  params[decodeURIComponent(key)] = decodeURIComponent(value || '');
              }
          });
      }
      return params;
  };

  // Split the URL at the fragment
  const [baseUrl, _fragment] = url.split('#');

  // Extract parameters from the base URL
  const queryParams = parseParams(baseUrl.split('?')[1]);

  // Clean up fragment so that it does not include string after hash
  const fragment = cleanUpFragment(_fragment)

  // Handle fragment parameters, considering both incorrect formats
  let fragmentParams = {};
  if (fragment) {
      // Check if there's a `?` in the fragment (incorrect format)
      if (fragment.includes('?')) {
          fragmentParams = parseParams(fragment.split('?')[1]);
      } else {
          // Handle fragment with `&` only
          fragmentParams = parseParams(fragment);
      }
  }

  // Combine both parameter objects
  return { ...queryParams, ...fragmentParams };
}